export const getDefaultDataSource = (businessAccount) => {
  let defaultDataSource = "stripe"
  const stripeConnected = businessAccount?.connected_payment_processors?.includes("stripe")
  const shopifyConnected = businessAccount?.connected_payment_processors?.includes("shopify")
  if (shopifyConnected && !stripeConnected) {
    defaultDataSource = "shopify"
  }
  return defaultDataSource
}
